// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <locker-item-status status=\"row.entity.Status\"></locker-item-status>\n</div>\n";
// Exports
module.exports = code;